import React from "react";
import { LuTrash2 } from "react-icons/lu";

const DeleteButton = ({ onClick }) => {
  return (
    <button
      onClick={onClick}
      className="inline-flex h-10 items-center justify-center gap-2 rounded-xl bg-red-600 px-5 font-medium text-white shadow-md shadow-red-600/25 transition-all duration-200 hover:bg-red-500 hover:-translate-y-0.5 active:translate-y-0 active:scale-[0.98] focus:outline-none focus:ring-2 focus:ring-red-500/40"
    >
      <LuTrash2 size={17} />
      <span>Delete</span>
    </button>
  );
};

export default DeleteButton;
